import React, { useEffect } from "react";
import { Form, Input, InputNumber, Button, Row, Col, message } from "antd";
import { createSpecialOffer, updateSpecialOffer } from "../../http/specialOfferAPI";

const { TextArea } = Input;

const SpecialOfferForm = ({ mode = "add", offer = null, onSuccess }) => {
  const [form] = Form.useForm();

  // Prefill form when editing
  useEffect(() => {
    if (offer) {
      form.setFieldsValue({
        nameAM: offer.nameAM,
        nameEN: offer.nameEN,
        nameRU: offer.nameRU,
        descriptionAM: offer.descriptionAM,
        descriptionEN: offer.descriptionEN,
        descriptionRU: offer.descriptionRU,
        price: offer.price,
      });
    }
  }, [offer, form]);

  const handleSubmit = async (values) => {
    try {
      if (mode === "add") {
        await createSpecialOffer(values);
        message.success("Special offer created!");
      } else {
        await updateSpecialOffer(offer.id, values);
        message.success("Special offer updated!");
      }

      form.resetFields();
      onSuccess?.();
    } catch (err) {
      console.error(err);
      message.error("Error saving special offer.");
    }
  };

  return (
    <Form layout="vertical" form={form} onFinish={handleSubmit}>
      <h3>{mode === "add" ? "Ավելացնել Հատուկ Առաջարկ" : "Թարմացնել Հատուկ Առաջարկ"}</h3>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="nameAM"
            label="Անուն (Հայերեն)"
            rules={[{ required: true, message: "Name (AM) is required" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="descriptionAM" label="Նկարագրություն (Հայերեն)">
            <TextArea rows={3} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name="nameEN"
            label="Անուն (Անգլերեն)"
            rules={[{ required: true, message: "Name (EN) is required" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="descriptionEN" label="Նկարագրություն (Անգլերեն)">
            <TextArea rows={3} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name="nameRU"
            label="Անուն (Ռուսերեն)"
            rules={[{ required: true, message: "Name (RU) is required" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="descriptionRU" label="Նկարագրություն (Ռուսերեն)">
            <TextArea rows={3} />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <Form.Item name="price" label="Արժեք">
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.01}
              placeholder="Մուտքագրեք արժեքը"
            />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Button type="primary" htmlType="submit" block>
          {mode === "add" ? "Create Offer" : "Update Offer"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SpecialOfferForm;
